/** Detect macOS / filesystem permission-denied errors vs corrupt/missing file errors. */

const PERMISSION_PATTERNS = [
  /operation not permitted/i,
  /permission denied/i,
  /eacces/i,
  /eperm/i,
  /not authorized.*read/i,
  /sandbox.*denied/i,
  /fda_permission_required/i,
];

export function isPermissionDeniedMessage(message: unknown): boolean {
  const text = String(message ?? '').trim();
  if (!text) return false;
  return PERMISSION_PATTERNS.some((re) => re.test(text));
}

export function isSourcePermissionOffline(healthEntry: unknown): boolean {
  if (!healthEntry || typeof healthEntry !== 'object') return false;
  const entry = healthEntry as Record<string, unknown>;
  if (entry.status !== 'offline') return false;

  const reason = entry.reason;
  if (reason === 'PermissionIssue' || reason === 'permission') return true;
  if (typeof reason === 'string') {
    if (reason === 'PermissionIssue') return true;
    return isPermissionDeniedMessage(reason);
  }
  if (reason && typeof reason === 'object') {
    const other = (reason as Record<string, unknown>).Other;
    if (typeof other === 'string') return isPermissionDeniedMessage(other);
  }
  return false;
}

export function sourceIdsWithPermissionIssue(
  sourceHealth: Record<string, unknown> | null | undefined,
): string[] {
  if (!sourceHealth) return [];
  return Object.entries(sourceHealth)
    .filter(([, health]) => isSourcePermissionOffline(health))
    .map(([id]) => id);
}
